import { render } from "./LegacyPublicPageFooter.vue?vue&type=template&id=121285e2"
import script from "./LegacyPublicPageFooter.vue?vue&type=script&lang=js"
export * from "./LegacyPublicPageFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/common/LegacyPublicPageFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "121285e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('121285e2', __exports__)) {
    api.reload('121285e2', __exports__)
  }
  
  module.hot.accept("./LegacyPublicPageFooter.vue?vue&type=template&id=121285e2", () => {
    api.rerender('121285e2', render)
  })

}


export default __exports__